import TreasuryIcon from './TreasuryIcon'

export default TreasuryIcon
